import React from 'react';

import imgRc from '../../assets/map-marker-rc.png';
import imgTom from '../../assets/map-marker-tom.png';

import './Marker.css';

function MapMarker(props) {
  function getImageByType() {
    switch (props.type) {
      // Atrium, ..., Loja, Organismo, Pronaos
      case 'A':
      case 'C':
      case 'L':
      case 'O':
      case 'P':
        return imgRc;
        // Heptada
      case 'H':
        return imgTom;
      default:
        return imgRc;
    }
  }
  if (!props.type) {
    return null;
  }

  const img = getImageByType();

  return (
    <div className={props.className} onClick={props.onClick}>
      <img src={img} alt="Organismo Afiliado" title="Organismo Afiliado" width={25} style={{ cursor: 'pointer' }} />
    </div>
  );
}


export default MapMarker;
